import React from "react";
import {List, Map} from "immutable";
import PropertiesList from "./PropertiesList";
import ActionButton from "../ActionButton";
import PanelGroupController from "../PanelGroupController";

const SearchQueriesPanel = (props) => {
  // Handle onChange and onClear by default (changes url query)
  const onChange = props.onChange || ((prop, value) => defaultOnChange(props.router, prop, value));
  const onClear = props.onClear || (() => defaultOnClear(props.router, props.properties));
  const query = props.query || Map(props.router.location.query);

  function handlePropertyClick(definition, values) {
    let input = window.prompt(`Search ${definition.get("label")}`, values.get(definition.get("prop"), ""));
    if (input !== null) {
      onChange(
        definition.get("prop"),
        input
      )
    }
  }

  return (
    <PanelGroupController title={props.title} expanded={props.expanded}>
      <PropertiesList properties={props.properties} data={query} allowPropertyClick={true} onPropertyClick={handlePropertyClick} />
      <ActionButton 
        label="Clear Search" 
        onClick={onClear} />
    </PanelGroupController>
  );
}

function defaultOnChange(router, prop, value) {
  let searchQueries = Map(router.location.query);
  if (value === "") {
    searchQueries = searchQueries.delete(prop);
  } else {
    searchQueries = searchQueries.set(prop, value);
  }
  router.push({
    pathname: router.location.pathname,
    query: searchQueries.toJS()
  });
}

function defaultOnClear(router, properties) {
  const searchQueries = Map(router.location.query);
  const searchOptionKeys = properties.map((val) => val.get("prop"));
  const emptySearchQueries = searchOptionKeys.reduce((acc, key) => {
    return acc.delete(key);
  }, searchQueries);

  router.push({
    pathname: router.location.pathname,
    query: emptySearchQueries.toJS()
  });
}

SearchQueriesPanel.defaultProps = {
  active: true,
  expanded: true,
  title: "Search Queries",
  properties: List(),
}

export default SearchQueriesPanel;